export default {
  unsaved: {
    title: 'Guardar as alterações?',
    description: 'Fez alterações a este passo que ainda não foram guardadas.',
    discard: 'Descartar',
    save_and_continue: 'Guardar e continuar',
  },
  title: 'Configurar o seu restaurante',
  nav: {
    completed: 'Concluído',
    locked: 'Gerido pelo seu fornecedor',
    aria_label: 'Passos de lançamento',
    step_label: 'Passo {{number}}',
    section_label: 'Lançamento',
    back_to_home: 'Voltar ao Início',
  },
  owner_invite: {
    hint: 'Prefere que o proprietário do restaurante conclua a configuração? Convide-o e ele continuará de onde ficou.',
    sent: 'Convite enviado para {{name}} ({{email}}) em {{date}}.',
  },
  footer: {
    step_of: 'Passo {{current}} de {{total}}',
  },
  buttons: {
    next_task: 'Próxima tarefa',
    cancel: 'Cancelar',
    back: 'Anterior',
    next: 'Continuar',
    save: 'Guardar',
    exit: 'Sair da configuração',
    retry: 'Tentar novamente',
  },
  errors: {
    progress_load_failed: 'Não foi possível carregar o progresso de configuração deste restaurante.',
    linked_company_unavailable: 'Este link é para um restaurante que não pode abrir, por isso está no atual.',
  },
  placeholder: {
    title: 'Este passo estará disponível em breve',
    description: 'O assistente e o acompanhamento de progresso estão prontos. Esta fase será construída a seguir.',
  },
  new_restaurant: {
    title: 'Novo restaurante',
    menu: {
      title: 'Menu',
      description: 'Uma demonstração ignora o onboarding, por isso importe o seu menu agora.',
    },
    demo: {
      title: 'Nova demonstração',
      description: 'Um restaurante de demonstração para testes — ignora a maior parte do onboarding.',
      label: 'Criar demonstração',
    },
    description: 'Diga-nos onde fica este restaurante. Iremos pesquisá-lo no Google Maps.',
  },
  location: {
    edit_description: 'Atualize a localização deste restaurante.',
    cta: 'Criar restaurante',
    section: {
      address: 'Informações básicas',
      group: 'Marca',
      group_description: 'Este local faz parte de uma marca que já tem?',
    },
    form: {
      name: {
        label: 'Nome do restaurante',
        placeholder: 'Pesquise o seu restaurante…',
        help: 'Comece a escrever para pesquisar este restaurante no Google Maps.',
      },
      address: {
        label: 'Morada',
        placeholder: 'Rua e número',
      },
      city: {
        label: 'Cidade',
      },
      zip_code: {
        label: 'Código postal',
      },
      country: {
        label: 'País',
      },
      region: {
        label: 'Estado / Região',
        placeholder: 'Selecione um estado ou região',
      },
    },
    group: {
      aria_label: 'Opções de marca',
      deferred_hint: 'Vai escolher o nome da marca e o endereço web no último passo.',
      existing: {
        title: 'Adicionar a uma marca existente',
        description: 'Outro local sob uma marca que já gere.',
        select_label: 'Marca',
        select_placeholder: 'Selecione uma marca',
      },
      new: {
        title: 'Criar uma nova marca',
        description: 'Um único restaurante, ou o primeiro local de uma nova marca.',
      },
    },
    toasts: {
      update_failed: 'Não foi possível guardar a localização. Tente novamente.',
      created: 'Restaurante criado',
      create_failed: 'Não foi possível criar o restaurante. Tente novamente.',
    },
  },
  domain: {
    url_setup: {
      title: 'Endereço de encomendas online',
      description: 'Onde os clientes farão as encomendas.',
    },
    modes: {
      foodamigos: {
        host_fallback: 'o seu domínio de encomendas online',
        title: 'Usar o nosso domínio genérico',
      },
      custom: {
        title: 'Ligar o seu próprio domínio',
        description: 'Use um domínio que o restaurante já possui.',
      },
    },
    toasts: {
      save_failed: 'Não foi possível guardar o endereço de encomendas online. Tente novamente.',
    },
  },
  go_live: {
    subtitle: 'Verifique que cada passo está concluído e ative os pedidos reais.',
    slug: {
      // Answers the open question in round-2 §8: PartialUpdateFranchiseRequest
      // carries no go-live guard on the slug, so it can be changed at any time —
      // but there is no redirect table, so the previous address stops resolving.
      // Saying so removes the hesitation without overpromising.
      help: 'Apenas letras, números e hífenes. Pode alterar isto mais tarde, mas o endereço antigo deixará de funcionar.',
      title: 'Endereço de encomendas online',
      description: 'É aqui que os seus clientes vão fazer pedidos. Pode alterar mais tarde.',
      label: 'Personalize com o nome do restaurante',
      placeholder: 'bella-italia',
      preview: 'A sua página de encomendas:',
      save: 'Guardar URL',
      saved: 'Endereço de encomendas online guardado',
      save_failed: 'Não foi possível guardar o URL. Tente novamente.',
      status: {
        checking: 'A verificar disponibilidade…',
        available: 'Disponível',
        taken: 'Este URL já está ocupado',
        invalid: 'Use apenas letras, números, hífens e underscores',
        error: 'Não foi possível verificar a disponibilidade — tente novamente',
      },
    },
    domain: {
      title: 'Domínio personalizado (opcional)',
      description: 'Use o seu próprio domínio em vez do endereço fornecido pela FoodAmigos.',
      add: '+ Adicionar domínio personalizado',
      hide: 'Ocultar domínio personalizado',
      label: 'O seu domínio',
      placeholder: 'shop.meurestaurante.com',
      save: 'Guardar',
      show_records: 'Mostrar registos DNS',
      hint: 'Apenas para encomendas — o seu website precisa de outro domínio. Por exemplo, order.omeurestaurante.com para a loja e omeurestaurante.com para o website.',
      records_after_save:
        'Assim que guardar o domínio, mostramos os registos exatos a adicionar no seu fornecedor de DNS — um domínio principal (omeurestaurante.com) e um subdomínio (order.omeurestaurante.com) precisam de registos diferentes.',
      saved: 'Domínio personalizado guardado',
      save_failed: 'Não foi possível guardar o domínio. Tente novamente.',
      unconfirmed: {
        title: 'Ativar a loja não depende deste domínio',
        description:
          'Até os seus registos serem confirmados, a página de encomendas fica no endereço predefinido, e o restaurante pode entrar em funcionamento aí. Assim que forem confirmados — pode demorar até 48 horas —, o domínio passa a mostrar a página de encomendas automaticamente.',
      },
    },
    locations: {
      title: 'Confirmar localizações',
      description: 'Cada local da sua marca tem o seu próprio endereço de encomendas. Confirme ou edite-os abaixo.',
      save: 'Guardar localizações',
      saved: 'URLs das localizações guardados',
      save_failed: 'Não foi possível guardar um ou mais URLs de localização. Tente novamente.',
    },
    preflight: {
      title: 'Antes de ativar a loja',
      description: 'Complete estes passos para ativar os pedidos reais.',
      url_setup: 'Endereço de encomendas configurado',
      online_payment: {
        your_provider: 'o seu fornecedor',
        payments_live: '{{title}} · concluído',
        online_payments_off: '{{title}} · sem pagamentos online',
        waiting_for_provider: '{{title}} · a aguardar {{provider}}',
        hosted_not_finished: '{{title}} · terminar com {{provider}}',
        action_needed: '{{title}} · ação necessária',
        waiting_for_partner: '{{title}} · a aguardar o seu parceiro',
        not_set_up: '{{title}} · não configurado',
        business_details_missing: '{{title}} · adicione os dados da empresa para os pagamentos',
      },
    },
    failed_checks: {
      title: 'Algumas coisas ainda precisam de atenção',
      items: {
        name: 'Nome do restaurante',
        logo_url: 'Logótipo',
        pictures: 'Fotos da galeria',
        menu_uploaded: 'Menu',
        opening_hours: 'Horário de funcionamento',
        address: 'Morada',
        storefront: 'Endereço de encomendas',
        payments_configured: 'Pagamentos',
        stripe_billing: 'Faturação',
        test_orders: 'Pedido de teste',
        google_business: 'Perfil Google Business',
        master_promo_code: 'Código promocional de boas-vindas',
        flyers_ordered: 'Flyers encomendados',
        identity: 'Tipo de restaurante e cozinhas',
        billing_payment_method: 'Método de pagamento',
        billing_license: 'Licença',
        business_name: 'Nome da empresa / do restaurante',
        payment_method: 'Numerário ou pagamentos online',
        stripe_processing_fee: 'Taxa de processamento do parceiro',
      },
      force: 'Ativar mesmo assim',
      blocker: '(obrigatório)',
      link: 'Abrir Faturação de Parceiro',
    },
    error: 'Não foi possível ativar os pedidos reais. Tente novamente.',
    gate_hint: 'Complete a lista acima para ativar o Go Live.',
    business_name: {
      label: 'Nome da empresa / do restaurante',
      help: 'Aparece nos seus termos de utilização e na sua política de privacidade. Use o nome com que a sua empresa opera.',
      save: 'Guardar',
      save_failed: 'Não foi possível guardar o nome da empresa. Tente novamente.',
      hint: 'Guarde primeiro o nome da empresa / do restaurante.',
    },
    cash_only: {
      message:
        'Os pagamentos online estão desativados — os clientes só podem pagar em numerário na recolha ou na entrega até um gateway estar ligado e verificado.',
    },
    payment_blocked: {
      title: 'Ative pagamentos em numerário ou configure pagamentos online para publicar.',
      payment_method: 'Os clientes precisam de uma forma de pagar.',
      turn_on_cash: 'Ativar pagamentos em numerário',
      ask_partner: 'Peça ao seu parceiro para ativar os pagamentos em numerário, ou',
      set_up_online: 'configure os pagamentos online',
    },
    buttons: {
      go_live: 'Go Live 🚀',
      finish: 'Concluir configuração',
    },
    celebration: {
      title: 'Está ativo!',
      title_named: '{{name}} está online!',
      subtitle: 'O seu restaurante está agora a aceitar pedidos reais.',
      license: '{{plan}} · ativo',
      license_trial: '{{plan}} · gratuito até {{date}}',
      finish: 'Concluir configuração',
    },
    service_fee: {
      title: 'Taxa de serviço',
      headline: 'Obtenha receitas extra sem cobrar aos seus restaurantes',
      subtitle:
        'Adicione uma pequena taxa de serviço que os clientes pagam no checkout. Fica com metade. Fica desativada até a ativar.',
      subtitle_share:
        'Adicione uma pequena taxa de serviço que os clientes pagam no checkout. Fica com {{share}}%. Fica desativada até a ativar.',
      tiles: {
        guest: {
          title: 'Paga pelo cliente',
          description: 'Mostrada no checkout, como nas apps de entrega.',
        },
        share: {
          title: 'Metade fica consigo',
          title_share: '{{share}}% ficam consigo',
          description: 'Divisão {{share}}/{{rest}} com a FoodAmigos.',
        },
        choice: {
          title: 'A decisão é sua',
          description: 'Desativada por defeito. Altere quando quiser.',
        },
      },
      preview: {
        title: 'O que os clientes veriam no checkout',
        subtotal: 'Subtotal do pedido',
        fee: 'Taxa de serviço',
        fee_terms: '({{percentage}}%, máx. {{max}})',
        guest_pays: 'O cliente paga',
        split_partner: '<strong>Você {{amount}}</strong> por pedido',
        split_provider: 'FoodAmigos {{amount}}',
        unchanged: 'O valor do pedido do restaurante não se altera.',
      },
      earnings: {
        title: 'O que poderia ganhar com este restaurante',
        orders: 'Pedidos online por mês',
        average_order: 'Pedido médio',
        per_month: 'por mês para si',
        collected: '{{amount}} cobrados aos clientes por mês. A sua parte: {{share}}%. Apenas estimativa.',
        effective_rate: 'Taxa efetiva em todos os pedidos: {{rate}}',
      },
      choice: {
        question: 'Adicionar uma taxa de serviço a este restaurante?',
        enabled: {
          title: 'Adicionar taxa de serviço',
          recommended: 'Recomendado: {{percentage}}%, máx. {{max}}',
          description: 'Os clientes pagam uma pequena taxa. Você recebe uma parte.',
        },
        skipped: {
          title: 'Sem taxa de serviço',
          description: 'Os clientes pagam apenas os preços do menu.',
        },
      },
      footer: {
        enabled:
          'Os clientes pagam {{percentage}}%, máx. {{max}} por pedido. Altere quando quiser em <settings>Definições de pedidos → Taxa de serviço</settings>.',
        skipped:
          'Sem taxa de serviço por agora. Altere quando quiser em <settings>Definições de pedidos → Taxa de serviço</settings>.',
      },
      enabled:
        'A taxa de serviço está agora ativa neste restaurante a {{percentage}}%, com limite de {{max}} por encomenda. Aplica-se a todas as novas encomendas a partir de agora. Altere-a em qualquer momento em <settings>Definições de encomendas → Taxa de serviço</settings>.',
      enabled_partner_default:
        'A taxa de serviço está agora ativa neste restaurante. Aplica-se a predefinição do seu parceiro: {{percentage}}%, com limite de {{max}} por encomenda. Aplica-se a todas as novas encomendas a partir de agora. Altere-a em qualquer momento em <settings>Definições de encomendas → Taxa de serviço</settings>.',
      buttons: {
        enable: 'Ativar taxa de serviço',
        continue_without: 'Continuar sem taxa',
      },
      skipped:
        'Os clientes deste restaurante não pagam taxa de serviço. Pode ativá-la em qualquer momento em <settings>Definições de encomendas → Taxa de serviço</settings>.',
      toasts: {
        save_failed: 'Não foi possível guardar a escolha da taxa de serviço. Tente novamente.',
      },
    },
  },
  toasts: {
    save_failed: 'Não foi possível guardar as alterações. Tente novamente.',
    saved: 'Guardado',
  },
  optional: 'Opcional',
  identity: {
    min_cuisine_hint: 'Selecione pelo menos uma cozinha para continuar.',
    sections: {
      restaurant_type: {
        title: 'Tipo de restaurante',
        description: 'Que tipo de estabelecimento é este?',
      },
      cuisine: {
        title: 'Tipos de cozinha',
        description: 'Escolha pelo menos um.',
      },
    },
  },
  menu: {
    modes: {
      recommended: 'Recomendado',
      import: {
        title: 'Importar de uma plataforma',
        description: 'Importe a ementa do Wolt, Lieferando, Deliveroo e mais.',
      },
      manual: {
        title: 'Criar a ementa de raiz',
        description: 'Crie categorias e itens manualmente no editor de ementa.',
      },
    },
    import: {
      title: 'Importar de plataforma existente',
      in_progress: {
        title: 'A importar a ementa…',
        description: 'Normalmente demora menos de dois minutos. Concluiremos este passo assim que terminar.',
      },
      failed: {
        title: 'A importação não foi concluída',
        description: 'Não foi possível concluir a importação da ementa. Verifique os detalhes e tente novamente.',
      },
      blocked: {
        until: 'Em pausa até {{time}}',
        release: 'Libertar a ligação',
        released: 'Ligação libertada. Pode iniciar a importação novamente.',
        release_failed: 'Não foi possível libertar a ligação. Tente novamente dentro de momentos.',
      },
      stalled: {
        title: 'Ainda a importar…',
        description:
          'A importação está a demorar mais do que o habitual. Pode ainda estar a correr em segundo plano — verifique novamente dentro de momentos. Iniciar uma nova importação agora pode duplicar a ementa.',
      },
    },
    manual: {
      title: 'Criar a ementa de raiz',
      description:
        'O editor de ementa abre com uma ementa vazia. Este passo fica concluído quando existir pelo menos uma categoria e um item.',
      open_editor: 'Abrir editor de ementa',
      waiting: {
        title: 'À espera do primeiro item da ementa',
        description: 'Assim que adicionar um item no editor de ementa, este passo pode ser concluído.',
      },
      found: {
        title: 'Itens da ementa detetados',
        description: 'Ótimo — pode continuar para o próximo passo.',
      },
    },
    complete: {
      title: 'Ementa pronta',
      description: 'A sua ementa está configurada. Pode revê-la a qualquer momento no editor de ementa.',
    },
    buttons: {
      start_import: 'Iniciar importação',
      importing: 'A importar…',
      retry: 'Repetir importação',
      check_again: 'Verificar novamente',
      continue: 'Continuar',
      skip: 'Ignorar por agora',
    },
  },
  phases: {
    // Stands in for the restaurant name in phase descriptions before it is known.
    fallback_name: 'este restaurante',
    location: {
      title: 'Localização',
      description: 'Onde fica o restaurante e a que marca pertence?',
    },
    identity: {
      title: 'Identidade',
      description: 'Tipo de restaurante e cozinhas.',
    },
    brand: {
      title: 'Marca',
      description: 'Logótipo, cores e galeria.',
    },
    operations: {
      title: 'Detalhes do local',
      description:
        'Configure como o {{name}} recebe pedidos. Este é o mínimo necessário antes de poder receber qualquer pedido.',
    },
    menu: {
      title: 'Menu',
      description:
        'Adicione a ementa do {{name}} à plataforma. Importe-a de uma plataforma existente em menos de dois minutos, ou crie-a de raiz.',
    },
    domain: {
      title: 'Domínio',
      description: 'O endereço web que os clientes usam para encomendar deste restaurante.',
    },
    go_live: {
      title: 'Go Live',
      description: 'Ativar pedidos reais.',
    },
    payouts: {
      title: 'Pagamento online',
      description: 'Como este restaurante recebe pagamentos online.',
    },
    service_fee: {
      title: 'Taxa de serviço',
      description:
        'Se os clientes pagam uma taxa de serviço no checkout. Pode alterá-lo mais tarde em Definições de encomendas → Taxas.',
    },
    bank_account: {
      title: 'Conta bancária',
      description:
        'Para onde vão os pagamentos. Não é necessária para entrar em funcionamento: os pagamentos ficam no saldo até ser adicionada uma conta.',
    },
  },
  business_details: {
    locked:
      'Estes detalhes são verificados com o seu fornecedor de pagamentos. Para os alterar, contacte a FoodAmigos.',
    section: {
      title: 'Detalhes da empresa',
    },
    fields: {
      business_type: {
        label: 'Tipo de negócio',
        options: {
          company: 'Empresa (GmbH, UG, Ltd, Inc — uma entidade jurídica registada)',
          individual: 'Individual (é o proprietário e gere o negócio pessoalmente)',
        },
      },
      owner_first_name: { label: 'Primeiro nome do proprietário' },
      owner_last_name: { label: 'Último nome do proprietário' },
      legal_name: {
        label: 'Nome legal da empresa',
        individual:
          'Gere o negócio pessoalmente, pelo que o nome do proprietário é usado como o nome legal da empresa.',
      },
      legal_address: { label: 'Morada registada' },
      legal_city: { label: 'Cidade' },
      legal_state: { label: 'Distrito ou região' },
      legal_zip_code: { label: 'Código postal' },
      legal_country: { label: 'País' },
      tax_id: {
        generic: 'Número fiscal ou de registo',
        personal: 'Apenas os últimos quatro dígitos são apresentados. Deixe como está para manter o número inalterado.',
        hint: 'Por exemplo, {{example}}.',
        invalid: 'Isto não corresponde ao formato habitual para este país e tipo de negócio, por exemplo, {{example}}.',
      },
      is_vat_registered: { label: 'Esta empresa está registada para efeitos de IVA' },
      vat_id: {
        label: 'Número de IVA',
        help: 'Começa com {{country}}, seguido de 8 a 12 letras ou dígitos.',
        invalid: 'O número de IVA deve começar com {{country}}, seguido de 8 a 12 letras ou dígitos.',
        help_unprefixed: 'O seu número de IVA ou de registo fiscal, tal como foi emitido.',
        invalid_unprefixed: 'Isto não parece um número de IVA: use entre 5 e 25 letras ou dígitos.',
      },
    },
    toasts: {
      save_failed: 'Não foi possível guardar os detalhes da empresa. Tente novamente.',
    },
  },
  brand: {
    fields: {
      short_name: {
        label: 'Nome curto',
        placeholder: 'ex.: Amigo Pizza',
        tooltip: 'Um nome de exibição mais curto usado na loja e nos recibos.',
      },
      primary_color: {
        label: 'Cor principal',
        invalid: 'Introduza uma cor hexadecimal válida, ex.: #1A73E8.',
      },
    },
    sections: {
      short_name: 'Nome',
      short_name_hint: 'Usado na loja, recibos e notificações.',
      logo_and_colour: 'Logótipo e cor principal da marca',
      logo: 'Carregar logótipo',
      logo_hint: 'Se deixar isto em branco, é usado o logótipo da sua marca.',
      gallery: 'Fotos da galeria',
      gallery_hint: 'Adicione até {{max}} fotos do seu restaurante. Arraste para reordenar.',
      gallery_count: '{{count}} de {{max}} adicionadas',
    },
    toasts: {
      image_uploaded: 'Imagem carregada',
      image_upload_failed: 'Não foi possível carregar a imagem. {{error}}',
      save_failed: 'Não foi possível guardar os dados da marca. Por favor, tente novamente.',
    },
  },
  operations: {
    contact: {
      title: 'Contacto',
      description: 'Utilizado para notificações de pedidos e comunicações com clientes.',
      phone: {
        label: 'Número de telefone do restaurante',
        placeholder: '+49 30 1234567',
        invalid: 'Introduza um número de telefone internacional completo, ex. +49 30 1234567',
      },
      email: { label: 'E-mail do restaurante', placeholder: 'pedidos@restaurante.com' },
    },
    methods: {
      title: 'Métodos de pedido',
      description: 'Como os clientes podem fazer pedidos e o tempo de cada método.',
      pickup: {
        label: 'Recolha',
        prep_time: { label: 'Tempo médio de preparação (min)' },
      },
      delivery: {
        label: 'Entrega',
        delivery_time: { label: 'Tempo médio de entrega (min)' },
        advanced_zones: 'Configuração avançada de zonas',
      },
    },
    timing: {
      title: 'Horário dos pedidos',
      description: 'Quando os clientes podem fazer pedidos — agora, mais tarde ou com antecedência.',
      at_least_one: 'Ative pedidos imediatos ou agendados (pelo menos um é obrigatório).',
      asap: { label: 'Aceitar pedidos imediatos' },
      scheduled: { label: 'Aceitar pedidos agendados' },
      reminders: { label: 'Enviar um lembrete automático antes da data prevista de uma encomenda agendada' },
      pre_order: {
        label: 'Permitir pré-encomendas para dias futuros',
        days: { label: 'Quantos dias de antecedência (0-31)' },
      },
    },
    tax: {
      title: 'IVA',
      description:
        'A taxa aplicada aos produtos deste restaurante. Começa com a taxa da região — altere-a apenas se este restaurante cobrar algo diferente.',
      rate: { label: 'Taxa de IVA', placeholder: 'ex. 7' },
      dedicated: { label: 'O IVA varia por produto' },
    },
    hours: {
      title: 'Horário de funcionamento',
      description: 'Os dias e horários em que este restaurante aceita pedidos.',
      same_every_day: 'Mesmo horário todos os dias',
      split_shifts: {
        title: 'Este restaurante tem horários de funcionamento divididos',
        description:
          'Alguns dias têm mais do que um período de abertura (por exemplo, turno de almoço e jantar). O editor simples mostra um período por dia, por isso mantemos os seus horários existentes — edite turnos divididos em Definições de pedidos → Horários de funcionamento.',
      },
    },
    toasts: {
      save_failed: 'Não foi possível guardar as definições operacionais. Por favor, tente novamente.',
    },
  },
  online_payment: {
    question: 'Pretende aceitar pagamentos online neste restaurante?',
    yes: 'Sim',
    not_now: 'Agora não',
    declined:
      'Os clientes pagam na recolha ou na entrega. Pode ativar os pagamentos online em qualquer altura nas Definições.',
    providers: {
      stripe: 'Stripe',
      adyen: 'Adyen',
    },
    waiting_for_partner: {
      staff: {
        title: 'Os pagamentos ainda não estão configurados para a sua conta parceira',
        description:
          'Um administrador da sua conta parceira precisa de escolher quem processa os pagamentos antes de este restaurante poder aceitar pagamentos online. Pode continuar com os outros passos entretanto.',
      },
    },
    continue_to_go_live: 'Continuar para Entrar em Funcionamento',
    platform_line: 'Os pagamentos deste restaurante são processados através dos pagamentos FoodAmigos.',
    only_connection: 'Os pagamentos são processados através de {{name}} (o seu único fornecedor ligado).',
    partner_issue: {
      title: 'O seu parceiro {{partner}} tem de concluir a configuração do fornecedor de pagamentos',
      description:
        'O fornecedor de pagamentos deles ainda não consegue integrar restaurantes. Já os avisámos — os seus dados estão guardados, por isso volte quando confirmarem que está resolvido.',
      retry_hint: 'Depois de resolvido, continue novamente para o fornecedor e tentaremos de novo.',
      open_settings: 'Abrir as definições do gateway de pagamento',
    },
    connect_another: 'Ligar outro fornecedor',
    checking: 'A verificar com {{provider}}…',
    checking_generic: 'A verificar com o fornecedor de pagamento…',
    retry: 'Tentar novamente',
    not_set_up: {
      title: 'Ainda não há um fornecedor de pagamentos associado',
      description:
        'O seu parceiro associa um fornecedor de pagamentos a este restaurante. Depois de o fazer, pode concluir a configuração aqui.',
    },
    choice: {
      title: 'Qual dos seus fornecedores associados deve este restaurante utilizar?',
      primary: 'Principal',
      confirm: 'Utilizar este fornecedor',
      cancel: 'Cancelar',
    },
    using: 'A utilizar {{name}}',
    change: 'Alterar',
    payout_details: {
      title: 'Dados da empresa para os pagamentos',
      description: 'Necessários ao fornecedor de pagamentos para verificar a sua empresa e enviar os pagamentos.',
      business_type: {
        company: {
          title: 'Empresa',
          description: 'GmbH, Lda., Ltd, Inc — uma pessoa coletiva registada',
        },
        individual: {
          title: 'Individual',
          description: 'É o proprietário e gere o negócio pessoalmente',
        },
      },
      registered_address: 'Morada registada',
      legal_address: 'Morada',
      legal_state: 'Estado / região',
      vat_id: 'NIF/IVA',
      optional: '(opcional)',
      fill_first: 'Preencha primeiro os dados da empresa para os pagamentos acima.',
    },
    hand_off: {
      title: 'A seguir: conclua a configuração com {{provider}}',
      description:
        '{{provider}} pedirá o documento de identidade do titular no seu próprio formulário, com base nos dados da empresa para pagamentos indicados acima. Cerca de 10 minutos. A conta bancária vem depois de entrar em funcionamento.',
      cta: 'Continuar para {{provider}}',
      transition: 'A encaminhar para {{provider}}…',
      error: 'Não foi possível abrir o formulário do {{provider}}. Tente novamente.',
    },
    states: {
      verified: 'Os pagamentos estão ativos.',
      submitted: {
        title: 'Dados enviados para {{provider}}',
        description:
          'A verificação demora geralmente 1 a 2 dias úteis. Enviaremos um e-mail ao proprietário do restaurante quando estiver concluída.',
        description_email:
          'A verificação demora normalmente 1–2 dias úteis. Enviaremos um email para {{email}} quando estiver concluída.',
        review: {
          business_type: 'Tipo de negócio',
          legal_name: 'Nome legal',
          address: 'Morada registada',
          types: {
            company: 'Empresa',
            individual: 'Individual',
          },
        },
      },
      incomplete: {
        title: 'Ainda não concluiu com {{provider}}',
        description: 'Os seus dados estão guardados — o link é válido durante 2 dias.',
        expired: 'Os seus dados estão guardados, mas o link expirou.',
        cta: 'Continuar com {{provider}}',
        new_link: 'Obter um novo link e continuar',
        check_details: 'Verificar primeiro os meus dados',
      },
      action_needed: {
        title: '{{provider}} precisa de mais uma coisa',
        description:
          '{{provider}} não conseguiu verificar um dos dados que forneceu. Abra novamente o formulário para corrigir.',
        cta: 'Abrir novamente o formulário do {{provider}}',
      },
    },
    connected: {
      title: 'Os pagamentos passam por {{name}}',
      description: 'Este restaurante está associado à conta {{name}} — não há mais nada a configurar aqui.',
      failed: 'Ainda não foi possível associar este restaurante a {{name}}',
    },
    errors: {
      generic: 'Ocorreu um erro. Tente novamente.',
      load_failed: 'Não foi possível carregar a configuração de pagamentos deste restaurante.',
    },
  },
  bank_account: {
    section: {
      title: 'Conta bancária para pagamentos',
      description: 'Os pagamentos são enviados em {{currency}}, a moeda em que este restaurante recebe pagamentos.',
    },
    done: 'Voltar ao painel',
    load_failed: 'Não foi possível carregar a conta bancária deste restaurante.',
    retry: 'Tentar novamente',
    no_permission: 'Só o proprietário do restaurante ou o parceiro pode introduzir a conta bancária.',
    confirm_with_provider: 'Confirmar com a Adyen',
    toasts: {
      save_failed: 'Não foi possível guardar a conta bancária. Verifique os dados.',
    },
  },
  payouts: {
    finish_setup: 'Concluir configuração',
  },
};
